import video1 from 'asset/video_3.webm';
import video2 from 'asset/NoAlpha.mp4';
// import video2 from 'asset/robot_light.mp4';

import thumb1 from 'asset/thumb_1.png';
import thumb2 from 'asset/thumb_2.png';

export const data_hero = {
  title: 'SoftServe <br/> <span>XR&nbsp;Design&nbsp;Pro</span>',
  description: `Enter a new age of machine customization with SoftServe XR Design Pro, an immersive, real-time VR/XR experience accelerated by NVIDIA Omniverse.
  <br/><br/>Watch virtual machines come to life in stunning detail. Explore every intricate feature, fine-tune every element, and experience unmatched realism.`,
  discoverMore: 'Discover more',
  items: [
    { id: 1, video: video1, thumb: thumb1 },
    { id: 2, video: video2, thumb: thumb2 },
  ],
};
